export const MISC_SUBPATHS = Object.freeze([
  '/about',
  '/contact',
  '/privacy',
  '/legal',
  '/advertising',
  '/newpandora',
  '/roku',
  '/u/',
  '/new/',
  'content/connect',
  'survey',
  'att/download',
  'iphone/register',
  'ipad/register',
  'squid-health',
  'radio-health',
  'sony_iptv',
  'restricted',
] as const);

export const GaPageGroups = Object.freeze({
  ALBUM_BACKSTAGE: 'album/backstage/',
  ARTIST_BACKSTAGE: 'artist/backstage/',
  ARTIST_NOW_PLAYING: 'artist/play/',
  PLAYLIST_BACKSTAGE: 'playlist/backstage/',
  PLAYLIST_NOW_PLAYING: 'playlist/play/',
  PODCAST_BACKSTAGE: 'podcast/backstage/',
  PODCAST_NOW_PLAYING: 'podcast/play/',
  PROFILE: 'profile/',
  STATION_BACKSTAGE: 'station/backstage/',
  STATION_NOW_PLAYING: 'station/play/',
  TRACK_BACKSTAGE: 'track/backstage/',
} as const);
